import { useEffect, useRef, useState } from 'react';

import './CourseCheckoutForm.scss';
import { withNavigationDelay } from '@helpers/link';

export default function CourseCheckoutForm({ pkg, addUserEvent }) {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: ''
  });
  const [agreed, setAgreed] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (pkg.name && formRef.current) {
      formRef.current.action = `https://pay.zwangerenportaal.nl/products/${encodeURIComponent(pkg.name)}`;
    }
  }, [pkg.name]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!e.currentTarget.checkValidity()) return;

    try {
      Promise.resolve(
        addUserEvent?.({
          variables: {
            type: `checkout:click-bestellen-button:${pkg.name}`,
            data: '{}'
          }
        })
      ).catch(() => {});
    } catch {}

    withNavigationDelay(() => {
      formRef.current?.submit();
    });
  };

  return (
    <form
      className="courseCheckout"
      method="POST"
      ref={formRef}
      onSubmit={handleSubmit}
    >
      <h2 className="courseCheckout-title">Jouw gegevens</h2>

      <div className="courseCheckout-inputs">
        <input
          name="firstname"
          type="text"
          placeholder="Voornaam"
          value={formData.firstname}
          onChange={handleChange}
          required
        />
        <input
          name="lastname"
          type="text"
          placeholder="Achternaam"
          value={formData.lastname}
          onChange={handleChange}
          required
        />
        <input
          name="email"
          type="email"
          placeholder="E-mailadres"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <h2 className="courseCheckout-subtitle">Besteloverzicht</h2>
      <div className="courseCheckout-summary">
        <div className="courseCheckout-line">
          <span>{pkg.title}</span>
          <span>€{pkg.price}</span>
        </div>

        <div className="courseCheckout-total">
          <span>Totaal</span>
          <span>€{pkg.price}</span>
        </div>

        <div className="courseCheckout-terms">
          <label className="courseCheckout-checkbox">
            <input
              required
              type="checkbox"
              checked={agreed}
              onChange={() => setAgreed(!agreed)}
            />
            <span className="checkmark" />
            Ik ga akkoord met de toepasselijkheid van de{' '}
            <a href="/privacyverklaring" target="_blank">
              Algemene Voorwaarden
            </a>{' '}
            op deze bestelling
          </label>
        </div>

        <button type="submit" className="courseCheckout-button cursor-pointer">
          Bestellen
        </button>
      </div>
    </form>
  );
}
